import { S3Client } from '@aws-sdk/client-s3';
const s3awsConfig = new S3Client({
  region: 'ap-south-1',
  credentials: {
    accessKeyId: 'AKIAUZPNLS7DVD5GSXM5',
    secretAccessKey: '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'
  }
});

export default s3awsConfig;
